/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TipoPraticaAttributoEsercenteValoreDTO } from './tipo-pratica-attributo-esercente-valore-dto';


export interface PagedModelTipoPraticaAttributoEsercenteValoreDTO { 
    content?: Array<TipoPraticaAttributoEsercenteValoreDTO>;
    page?: PageMetadata;
}

